import { render } from "./BreakDownType.vue?vue&type=template&id=6ce71f70"
import script from "./BreakDownType.vue?vue&type=script&lang=js"
export * from "./BreakDownType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__